import { IconDeviceFloppy } from '@tabler/icons-react'
import React, { useMemo, useState } from 'react'
import { Modal, Form } from 'react-bootstrap'
import { CancelBtn } from './Buttons/CancelBtn'
import { SubmitBtn } from './Buttons/SubmitBtn'
import { PostRequest } from '../Utils/hooks/ApiHandler'
import useLocalStorageState from 'use-local-storage-state'
import { useNavigate } from 'react-router-dom'
import Select from "react-select"
import { customStyles } from '../Utils/helpers/commonhelper'

export const BulkUpdateModal = ({
    show,
    onHide,
    onSubmit,
    headers,
    extras,
    selectedIds,
    fieldData,
    setFieldData,
    columnForBulkUpdate,
    loading
}) => {

    const [showCorrespondingField, setShowCorrespondingField] = useState(false)

    // variable to find the option or input corresponding to selected value
    const selectedField = useMemo(() => {
        return columnForBulkUpdate.find(c => c.value === fieldData?.fieldId)
    }, [fieldData])
    return (
        <Modal
            style={{ zIndex: 9999 }}
            show={show}
            onHide={() => {
                onHide()
                setFieldData(null)
                setShowCorrespondingField(false)
            }}
            contentClassName="border-0 shadow-lg rounded-3"
        >
            <Modal.Header closeButton className="border-bottom-0 pt-4 px-4 align-items-start">
                <div className="d-flex flex-column">
                    <div className="d-flex align-items-start mb-1 gap-2">
                        <div
                            className="d-flex align-items-center justify-content-center rounded-2"
                            style={{
                                background: "linear-gradient(135deg, #7a3a5e 0%, #4f243c 100%)",
                                width: "38px",
                                height: "38px",
                                boxShadow: "0 4px 10px rgba(122, 58, 94, 0.2)"
                            }}
                        >
                            <IconDeviceFloppy stroke={2} size={20} color={"white"} />
                        </div>
                        <div className="d-flex flex-column">
                            <Modal.Title className="h5 fw-bold m-0" style={{ color: '#1a202c' }}>
                                Save Updates
                            </Modal.Title>
                            <small className="text-muted">
                                Bulk update multiple items across respective fields.
                            </small>
                        </div>
                    </div>

                </div>
            </Modal.Header>

            <Modal.Body className="px-4 py-3">
                <Form className="form-container" >
                    {/* <Form className="form-container"> */}
                    <Form.Group className="mb-4 focus-z-index position-relative " controlId="filterName">
                        <Form.Label className="small fw-semibold text-secondary " style={{ fontSize: '11px', }}></Form.Label>
                        <label htmlFor="parentSelect"> Select Field</label>
                        <Select
                            id='parentSelect'
                            options={columnForBulkUpdate}
                            onChange={(selectedOption) => {
                                setFieldData({
                                    fieldId: selectedOption?.value ?? null,
                                    fieldValue: null,
                                });
                                setShowCorrespondingField(true)
                            }}
                            value={
                                columnForBulkUpdate.find(
                                    (option) => option?.value === fieldData?.fieldId
                                )
                            }
                            styles={customStyles}
                        />
                    </Form.Group>
                    {
                        showCorrespondingField &&
                        <Form.Group controlId="filterDescription" className="mb-3 position-relative focus-z-index">

                            <Form.Label className="mb-3 position-relative focus-z-index" className="small fw-semibold text-secondary " style={{ fontSize: '11px', }}>
                                Select {selectedField?.type !== "date-range" ? "Value" : 'Date'}
                            </Form.Label>

                            {(selectedField?.option === null || selectedField?.type === "date-range") ? (
                                < div className="d-flex-col gap-2">
                                    <div className='d-flex gap-2'>
                                        <input
                                            type="date"
                                            className="form-control form-control-sm"
                                            // value={filter.value?.start || ""}
                                            onChange={(e) => setFieldData(prev => ({ ...prev, fieldValue: e.target.value }))}
                                        />
                                    </div>
                                </div>

                            ) : (
                                <Select
                                    onChange={(selectedOption) => setFieldData(prev => ({ ...prev, fieldValue: selectedOption.value }))}
                                    options={selectedField?.option}
                                    value={selectedField?.option?.find((opt) => opt.value === fieldData?.fieldValue) || null}
                                    menuPortalTarget={document.body}
                                    styles={customStyles}
                                />
                            )}
                        </Form.Group>
                    }
                    <div className="d-flex justify-content-end gap-2 mt-4 pt-2 pb-2">
                        <CancelBtn
                            type={'button'}
                            onClick={() => {
                                onHide()
                                setFieldData(null)
                                setShowCorrespondingField(false)
                            }}
                            submitClicked={loading}
                        />
                        <SubmitBtn
                            type={'button'}
                            loading={loading}
                            title={"Save Filter"}
                            disabled={
                                !fieldData?.fieldValue
                            }
                            onClick={onSubmit}
                        />
                    </div>
                </Form>
            </Modal.Body>
        </Modal >
    )
}
